// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-list-item[data-v-f89f3da0] {\n  justify-content: left !important;\n}\n", ""]);
// Exports
module.exports = exports;
